var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0)" } }, [
        _c("path", {
          attrs: {
            d:
              "M21.9972 15.7499L21.9994 15.7499C22.9545 15.7581 23.7381 14.9773 23.75 14.0042L23.75 2.0063C23.7462 1.53569 23.5589 1.08617 23.2297 0.756802C22.9014 0.428269 22.4589 0.246149 21.9972 0.250071L2.00064 0.250062C1.54109 0.246149 1.09858 0.428269 0.770279 0.756802C0.441145 1.08617 0.253838 1.53569 0.250008 2.00426L0.25 13.9937C0.253838 14.4643 0.441145 14.9138 0.770279 15.2432C1.09858 15.5717 1.54109 15.7538 2.00277 15.7499H21.9972ZM21.9962 16.2499C21.9958 16.2499 21.9955 16.2499 21.9951 16.2499L21.9972 16.2499H21.9962Z",
            fill: "white",
            stroke: "black",
            "stroke-opacity": "0.2",
            "stroke-width": "0.5"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M12.6124 15.9999H21.9973C22.524 16.0043 23.031 15.7993 23.4066 15.4299C23.7822 15.0605 23.9956 14.5571 24 14.0303V11.6717C20.4562 13.706 16.6128 15.1668 12.6124 15.9999Z",
            fill: "#F27712"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M23.1724 9.29649H22.32L21.36 8.03029H21.269V9.29649H20.5738V6.15167H21.6C22.4028 6.15167 22.8662 6.4827 22.8662 7.07856C22.8662 7.56684 22.5766 7.88132 22.0552 7.98063L23.1724 9.29649ZM22.1462 7.10339C22.1462 6.79718 21.9145 6.63994 21.4841 6.63994H21.269V7.59167H21.4676C21.9145 7.59167 22.1462 7.42615 22.1462 7.10339ZM18.1407 6.15167H20.1104V6.68132H18.8359V7.38477H20.0607V7.9227H18.8359V8.77512H20.1104V9.30477H18.1407V6.15167ZM15.9062 9.37925L14.4 6.14339H15.1614L16.1131 8.26201L17.0731 6.14339H17.8179L16.2952 9.37925H15.9228H15.9062ZM9.60828 9.37098C8.54897 9.37098 7.72139 8.65098 7.72139 7.71581C7.72139 6.80546 8.56553 6.06891 9.62484 6.06891C9.92277 6.06891 10.171 6.12684 10.4773 6.25925V6.98753C10.2454 6.75971 9.93336 6.63194 9.60828 6.63167C8.94621 6.63167 8.44139 7.11167 8.44139 7.71581C8.44139 8.35305 8.93794 8.80822 9.64139 8.80822C9.95587 8.80822 10.1959 8.70891 10.4773 8.46063V9.18891C10.1628 9.32132 9.89794 9.37098 9.60828 9.37098ZM7.50622 8.33649C7.50622 8.94891 7.00139 9.37098 6.27311 9.37098C5.74346 9.37098 5.36277 9.18891 5.04001 8.77512L5.49518 8.38615C5.65242 8.66753 5.91725 8.80822 6.24828 8.80822C6.56277 8.80822 6.78622 8.61787 6.78622 8.3696C6.78622 8.22891 6.72001 8.12132 6.57932 8.03856C6.42506 7.96371 6.26442 7.90277 6.09932 7.85649C5.44553 7.6496 5.22208 7.42615 5.22208 6.98753C5.22208 6.47443 5.70208 6.08546 6.33104 6.08546C6.72828 6.08546 7.08415 6.2096 7.38208 6.44132L7.01794 6.85512C6.87362 6.6969 6.66934 6.60677 6.45518 6.60684C6.15725 6.60684 5.94208 6.75581 5.94208 6.95443C5.94208 7.11994 6.06622 7.21098 6.48001 7.35167C7.27449 7.59994 7.50622 7.83167 7.50622 8.34477V8.33649ZM4.08828 6.15167H4.78346V9.30477H4.08828V6.15167ZM1.8538 9.30477H0.827595V6.15167H1.8538C2.97932 6.15167 3.75725 6.79718 3.75725 7.72408C3.75725 8.19581 3.52553 8.6427 3.12001 8.94063C2.77242 9.18891 2.38346 9.30477 1.84553 9.30477H1.8538ZM2.66484 6.93787C2.43311 6.75581 2.16828 6.6896 1.71311 6.6896H1.52277V8.77512H1.71311C2.16001 8.77512 2.44139 8.69236 2.66484 8.52684C2.90484 8.32822 3.04553 8.03029 3.04553 7.72408C3.04553 7.41787 2.90484 7.12822 2.66484 6.93787Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M12.4138 6.06891C11.5035 6.06891 10.7586 6.79718 10.7586 7.69925C10.7586 8.65925 11.4704 9.37925 12.4138 9.37925C13.3407 9.37925 14.069 8.65098 14.069 7.72408C14.069 6.79718 13.349 6.06891 12.4138 6.06891Z",
            fill: "#F27712"
          }
        })
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0" } }, [
          _c("rect", { attrs: { width: "24", height: "16", fill: "white" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }